export const taskData =
    [
        { value: 'ITR Return', label: 'ITR Return' },
        { value: 'GST Filling', label: 'GST Filling' },
        { value: 'Income Tax Filling', label: 'Income Tax Filling' },
        { value: 'Auditing', label: 'Auditing' },
        { value: 'Latigation Cases', label: 'Latigation Cases' },
        { value: 'other', label: 'other' },
    ];